import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { InventoryItem, RoomInventory } from '../../../shared/types/Inventory';
import { ChevronLeftIcon, ChevronRightIcon, PlusIcon, MoreHorizontalIcon } from 'lucide-react';
import { AddInventoryModal } from '../components/AddInventoryModal';
export function Inventory() {
  const {
    t
  } = useTranslation('shops');
  // Date range state
  const [dateRange, setDateRange] = useState('05/06/2026 - 06/06/2026');
  // Modal state
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  // Mock inventory data based on the screenshot
  const [inventoryData, setInventoryData] = useState<InventoryItem[]>([{
    date: '2026-05-06',
    dayOfWeek: 'Wednesday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2026-05-07',
    dayOfWeek: 'Thursday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2026-05-08',
    dayOfWeek: 'Friday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2026-05-09',
    dayOfWeek: 'Saturday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2026-05-10',
    dayOfWeek: 'Sunday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }]);
  // Room type filter
  const [roomTypeFilter, setRoomTypeFilter] = useState('all');
  // Format date for display
  function formatDate(dateString: string): string {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')} Oct ${date.getFullYear()}`;
  }
  // Handle adding new inventory
  const handleSaveInventory = (inventoryData: any) => {
    console.log('New inventory data:', inventoryData);
    // Here you would process the new inventory data and update the state
    // This is just a placeholder for the actual implementation
    // For demonstration, let's add a simple log message
    alert('Inventory added successfully!');
  };
  return <div className="space-y-6" data-id="element-11595">
      <div className="flex justify-between items-center" data-id="element-11596">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-11597">
          {t('pages.Inventory.inventory')}
        </h1>
        <button onClick={() => setIsAddModalOpen(true)} className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md flex items-center" data-id="element-11598">
          <PlusIcon size={18} className="mr-1" data-id="element-11599" />
          {t('components.AddInventoryModal.add_inventory')}
        </button>
      </div>
      {/* Date range and filters */}
      <div className="flex flex-wrap gap-3" data-id="element-11600">
        <div className="relative" data-id="element-11601">
          <input type="text" className="border border-gray-300 rounded-md px-3 py-2 w-48" value={dateRange} readOnly data-id="element-11602" />

          <div className="absolute inset-y-0 right-0 flex items-center pr-2" data-id="element-11603">
            <ChevronLeftIcon size={16} className="text-gray-400 cursor-pointer mr-1" data-id="element-11604" />

            <ChevronRightIcon size={16} className="text-gray-400 cursor-pointer" data-id="element-11605" />
          </div>
        </div>
        <select className="border border-gray-300 rounded-md px-3 py-2" value={roomTypeFilter} onChange={e => setRoomTypeFilter(e.target.value)} data-id="element-11606">
          <option value="all" data-id="element-11607">
            {t('components.AddInventoryModal.select_room_type')}
          </option>
          <option value="premium-overwater" data-id="element-11608">
            {t('components.AddInventoryModal.premium_overwater_villa')}
          </option>
          <option value="water-villa" data-id="element-11609">
            {t('components.AddInventoryModal.water_villa')}
          </option>
        </select>
      </div>
      {/* Inventory Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-x-auto" data-id="element-11610">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-11611">
          <thead className="bg-gray-50" data-id="element-11612">
            <tr data-id="element-11613">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-11614">
                {t('pages.Inventory.room_type')}
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-11615">
                {t('pages.Inventory.available_rooms')}
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-11616">
                {t('pages.Inventory.cta')}
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-11617">
                {t('pages.Inventory.ctd')}
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-11618">
                {t('pages.Inventory.blo')}
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-11619">
                {t('pages.CampaignDetails.actions')}
              </th>
            </tr>
          </thead>
          <tbody data-id="element-11620">
            {inventoryData.map((day, dayIndex) => <Fragment key={day.date} data-id="element-11621">
                {/* Date header */}
                <tr className="bg-gray-50" data-id="element-11622">
                  <td colSpan={6} className="px-6 py-3" data-id="element-11623">
                    <div className="font-medium text-gray-900" data-id="element-11624">
                      {formatDate(day.date)}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-11625">{day.dayOfWeek}</div>
                  </td>
                </tr>
                {/* Room inventory rows */}
                {day.roomTypes.map((room, roomIndex) => <tr key={`${day.date}-${room.roomCode}`} className="bg-white" data-id="element-11626">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-11627">
                      <div className="text-sm font-medium text-gray-900" data-id="element-11628">
                        {room.roomType}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-11629">
                        {room.roomCode}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-11630">
                      {room.availableRooms}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-11631">
                      <input type="checkbox" checked={room.cta} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].cta = !room.cta;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-11632" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-11633">
                      <input type="checkbox" checked={room.ctd} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].ctd = !room.ctd;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-11634" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-11635">
                      <input type="checkbox" checked={room.blo} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].blo = !room.blo;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-11636" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right" data-id="element-11637">
                      <button aria-label="Inventory actions" className="text-gray-400 hover:text-gray-500" data-id="element-11638">
                        <MoreHorizontalIcon size={18} aria-hidden="true" data-id="element-11639" />
                      </button>
                    </td>
                  </tr>)}
              </Fragment>)}
          </tbody>
        </table>
      </div>
      {/* Add Inventory Modal */}
      <AddInventoryModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} onSave={handleSaveInventory} data-id="element-11640" />
    </div>;
}